import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { PlayerSoftwareComponent } from '../../../../../pages/datasets/player-software/player-software.component';
import { PlayerSoftwareEditComponent } from 'src/app/pages/datasets/player-software-edit/player-software-edit.component';

export const playerSoftware: Route = {
  path: 'player-software',
  title: 'nav.network.playerSoftware',
  data: {
    breadcrumb: 'nav.network.playerSoftware',
    icon: SbIcons.playerSoftware,
    id: RoutingID.playerSoftware,
  },
  children: [
    {
      path: '',
      component: PlayerSoftwareComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'player-software-edit/:playerSoftwareID',
      title: 'nav.datasets.device.software.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.device.software.edit',
        id: RoutingID.deviceSoftwareEdit,
      },
      children: [
        {
          path: '',
          component: PlayerSoftwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'player-software-create',
      title: 'nav.datasets.device.software.create',
      data: {
        breadcrumb: 'nav.datasets.device.software.create',
        icon: SbIcons.plus,
        id: RoutingID.deviceSoftwareCreate,
      },
      children: [
        {
          path: '',
          component: PlayerSoftwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
